import React from "react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { EmailNotification } from "@/api/fetchMyEmailNotifications/types";
import { EllipsisVerticalIcon, EyeIcon } from "@heroicons/react/24/outline";

/**
 * Props for the dropdown actions:
 *  - notification: The current EmailNotification row
 *  - onPreview: callback to show preview modal
 */
interface MyEmailNotificationActionMenuProps {
  notification: EmailNotification;
  onPreview: (notif: EmailNotification) => void;
}

const MyEmailNotificationActionMenu: React.FC<
  MyEmailNotificationActionMenuProps
> = ({ notification, onPreview }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="h-8 w-8 p-0 hover:bg-gray-200" variant="ghost">
          <span className="sr-only">Open actions menu</span>
          <EllipsisVerticalIcon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-[160px] p-2 bg-white">
        <DropdownMenuItem
          className="flex cursor-pointer items-center px-3 py-2 text-sm hover:bg-gray-100"
          onClick={() => onPreview(notification)}
        >
          <EyeIcon className="mr-2 h-4 w-4 text-gray-500" />
          Preview
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MyEmailNotificationActionMenu;
